export default "__VITE_ASSET__CuRcSWsA__"